import React from 'react';

export default function Privacy() {
  return (
    <div className="pt-32 pb-24 bg-light min-h-screen">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 bg-white p-8 md:p-12 rounded-3xl shadow-sm border border-gray-100">
        <h1 className="text-3xl md:text-4xl font-bold text-navy mb-6">Kebijakan Privasi</h1>
        <div className="w-20 h-1.5 bg-orange mb-8 rounded-full"></div>

        <div className="space-y-6 text-gray-600 leading-relaxed">
          <section>
            <h2 className="text-xl font-bold text-navy mb-3">1. Pengumpulan Informasi</h2>
            <p>Kami mengumpulkan informasi pribadi yang Anda berikan secara sukarela saat menggunakan layanan kami, termasuk namun tidak terbatas pada nama lengkap, alamat, alamat email, nomor WhatsApp/telepon, dan detail barang yang dikirimkan.</p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-navy mb-3">2. Penggunaan Informasi</h2>
            <p>Informasi Anda digunakan semata-mata untuk keperluan operasional pengiriman barang, pelacakan pesanan, penagihan, komunikasi layanan pelanggan, dan peningkatan mutu kualitas layanan dari Garuda Ekspress Logistik.</p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-navy mb-3">3. Keamanan Data</h2>
            <p>Kami menerapkan dan mematuhi standar langkah-langkah keamanan teknis serta administratif yang wajar untuk melindungi data pribadi Anda dari akses, penggunaan, atau pengungkapan yang tidak sah.</p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-navy mb-3">4. Pembagian Informasi</h2>
            <p>Kami tidak akan menjual, menyewakan, atau memperdagangkan informasi pribadi Anda kepada pihak ketiga. Informasi hanya dapat dibagikan kepada mitra kurir internal kami atau pihak berwajib jika dan hanya jika diwajibkan oleh proses hukum.</p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-navy mb-3">5. Hak Pengguna</h2>
            <p>Anda berhak untuk meminta pembaruan, koreksi, atau penghapusan sebagian data pribadi Anda yang tersimpan di sistem kami dengan menghubungi pusat layanan pelanggan kami yang tertera pada halaman utama.</p>
          </section>
        </div>
      </div>
    </div>
  );
}